export const localization = {
  pt: {
    title: 'Atualizar arquivo',
    subtitle: 'Importe um novo arquivo para atualizar a base de conhecimento atual.',
    fileUpload: {
      title: 'Importar arquivos',
      subtitle: 'Você pode enviar arquivos nos formatos XLSX, CSV, PDF, TXT, DOCX e PPTX',
    },
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    successToast: {
      title: 'Conteúdo atualizado',
      message: 'O conteúdo foi salvo e está disponível no catálogo.',
    },
    errorToast: {
      title: 'Falha ao atualizar o conteúdo',
      message: 'Não foi possível salvar o conteúdo. Tente novamente.',
    },
  },
  en: {
    title: 'Update file',
    subtitle: 'Import a new file to update the current knowledge base.',
    fileUpload: {
      title: 'Import files',
      subtitle: 'You can upload files in XLSX, CSV, PDF, TXT, DOCX and PPTX formats',
    },
    cancelButton: 'Cancel',
    saveButton: 'Save',
    successToast: {
      title: 'Content updated',
      message: 'The content has been saved and is available in the catalog.',
    },
    errorToast: {
      title: 'Could not update content',
      message: 'Could not save the content. Please try again.',
    },
  },
  es: {
    title: 'Actualizar archivo',
    subtitle: 'Importa un nuevo archivo para actualizar la base de conocimiento actual.',
    fileUpload: {
      title: 'Importar archivos',
      subtitle: 'Puedes enviar archivos en formatos XLSX, CSV, PDF, TXT, DOCX y PPTX',
    },
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    successToast: {
      title: 'Contenido actualizado',
      message: 'El archivo se ha actualizado correctamente y está siendo procesado.',
    },
    errorToast: {
      title: 'Fallo al actualizar el contenido',
      message: 'No se pudo actualizar el archivo. Inténtalo de nuevo.',
    },
  },
};
